import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "detail-info-row" }
const _hoisted_7 = { class: "detail-info-pair" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "detail-info-pair__label fw-bold text-muted" }, "Tên nhóm", -1)
const _hoisted_9 = { class: "detail-info-pair__value" }
const _hoisted_10 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_11 = { class: "detail-info-pair" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "detail-info-pair__label fw-bold text-muted" }, "Ngày tạo", -1)
const _hoisted_13 = { class: "detail-info-pair__value" }
const _hoisted_14 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_15 = { class: "detail-info-row" }
const _hoisted_16 = { class: "detail-info-pair" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "detail-info-pair__label fw-bold text-muted" }, "Mô tả:", -1)
const _hoisted_18 = { class: "detail-info-pair__value" }
const _hoisted_19 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_20 = { class: "detail-info-pair" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "detail-info-pair__label fw-bold text-muted" }, "Mã nhóm:", -1)
const _hoisted_22 = { class: "detail-info-pair__value" }
const _hoisted_23 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_24 = {
  key: 0,
  class: "detail-info-row detail-info-row--single"
}
const _hoisted_25 = { class: "detail-info-pair" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "detail-info-pair__label fw-bold text-muted" }, "Nhóm cha:", -1)
const _hoisted_27 = { class: "detail-info-pair__value" }
const _hoisted_28 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_29 = { class: "detail-info-row detail-info-row--single" }
const _hoisted_30 = { class: "detail-info-pair" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "detail-info-pair__label fw-bold text-muted d-flex flex-row align-items-center" }, "Phân cấp cuối cùng:", -1)
const _hoisted_32 = { class: "detail-info-pair__value" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalThemToaXe = _resolveComponent("ModalThemToaXe")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_Can = _resolveComponent("Can")!
  const _component_DetailTopicLottie = _resolveComponent("DetailTopicLottie")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_DinhMucCoDinhToaXeSection = _resolveComponent("DinhMucCoDinhToaXeSection")!
  const _component_DanhSachToaXe = _resolveComponent("DanhSachToaXe")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.danhMucToaXe)
      ? (_openBlock(), _createBlock(_component_ModalThemToaXe, {
          key: 0,
          "is-modal-open": _ctx.isModalOpen,
          "selected-toa-xe-items": _ctx.danhMucToaXe.toa_xe,
          "danh-muc-toa-xe-id": _ctx.danhMucToaXeId,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isModalOpen = false)),
          onAdded: _ctx.onAddedToaXeItems
        }, null, 8, ["is-modal-open", "selected-toa-xe-items", "danh-muc-toa-xe-id", "onAdded"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": _ctx.isDeletingModalDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeletingModalDisplay = false)),
      onOnCloseIconClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDeletingModalDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.danhMucToaXe)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa nhóm toa xe "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.danhMucToaXe.ten_danh_muc), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": !!_ctx.removingToaXe,
      onOnConfirmButtonClick: _ctx.confirmRemoveVatTu,
      onOnCloseButtonClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removingToaXe = null)),
      onOnCloseIconClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removingToaXe = null))
    }, {
      default: _withCtx(() => [
        (_ctx.removingToaXe)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_3, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa toa xe "),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.removingToaXe.ten_toa_xe), 1),
              _createTextVNode(" khỏi nhóm toa xe "),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.danhMucToaXe?.ten_danh_muc), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        (_ctx.danhMucToaXe)
          ? (_openBlock(), _createBlock(_component_PageContentSection, {
              key: 0,
              "always-expanded": true
            }, {
              header: _withCtx(() => [
                _createTextVNode(" Thông tin ")
              ]),
              actions: _withCtx(() => [
                _createVNode(_component_Can, {
                  all: [_ctx.DANH_MUC_TOA_XE.SUA]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonCustom, {
                      classes: `rounded-none m-0`,
                      "button-type": _ctx.ButtonsType.EDIT,
                      "color-type": _ctx.ButtonTypeColors.SUCCESS,
                      "tooltip-message": "Chỉnh sửa",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (
              _ctx.push(`/quan-ly/danh-muc-toa-xe/cap-nhat/${_ctx.danhMucToaXeId}`)
            ))
                    }, null, 8, ["button-type", "color-type"])
                  ]),
                  _: 1
                }, 8, ["all"]),
                _createVNode(_component_Can, {
                  all: [_ctx.DANH_MUC_TOA_XE.XOA]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonCustom, {
                      classes: `rounded-none m-0`,
                      "button-type": _ctx.ButtonsType.TRASH,
                      "color-type": _ctx.ButtonTypeColors.DANGER,
                      "tooltip-message": "Xoá",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDeletingModalDisplay = true))
                    }, null, 8, ["button-type", "color-type"])
                  ]),
                  _: 1
                }, 8, ["all"])
              ]),
              illustration: _withCtx(() => [
                _createVNode(_component_DetailTopicLottie, { topic: "danh-muc-toa-xe" })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.danhMucToaXe.ten_danh_muc), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.moment(_ctx.danhMucToaXe.created_at).format("DD/MM/YYYY")), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.danhMucToaXe.mo_ta), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.danhMucToaXe.ma_danh_muc), 1)
                    ])
                  ])
                ]),
                (_ctx.danhMucToaXe.parent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.danhMucToaXe.parent.ten_danh_muc), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_el_checkbox, {
                        class: "mt-0",
                        disabled: "",
                        "model-value": _ctx.isPhanCapCuoiCung
                      }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      }, 8, ["model-value"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.danhMucToaXe)
          ? (_openBlock(), _createBlock(_component_DinhMucCoDinhToaXeSection, {
              key: 1,
              "dinh-muc-co-dinh-items": 
        _ctx.danhMucToaXe.dinh_muc_co_dinh ? _ctx.danhMucToaXe.dinh_muc_co_dinh : []
      ,
              "danh-muc-toa-xe-id": _ctx.danhMucToaXeId,
              onAdded: _ctx.fetchData
            }, null, 8, ["dinh-muc-co-dinh-items", "danh-muc-toa-xe-id", "onAdded"]))
          : _createCommentVNode("", true),
        (_ctx.danhMucToaXe && _ctx.danhMucToaXe && _ctx.danhMucToaXe.phan_cap === 1)
          ? (_openBlock(), _createBlock(_component_DanhSachToaXe, {
              key: 2,
              ref: "danhSachToaXeRef",
              "danh-muc-toa-xe-id": _ctx.danhMucToaXeId,
              "show-edit-button": false,
              onOpenAddToaXeItemsModal: _ctx.openModal,
              onOnDeleteButtonClicked: _cache[7] || (_cache[7] = ({ toaXe }) => (_ctx.removingToaXe = toaXe))
            }, null, 8, ["danh-muc-toa-xe-id", "onOpenAddToaXeItemsModal"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}